import React, { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { AppButton, IconButton, MenuBtn } from '../buttons'
import { RiLogoutCircleRLine, RiUserLine } from "react-icons/ri"
import { HiOutlineXMark } from "react-icons/hi2"

import { Avatar, Button, Tooltip } from 'flowbite-react';

import { Link } from 'react-router-dom';
import { AppContext } from '../../../modules/contexts/AppContexts';

import user_alt_img from './../../../assets/user_alt.webp'
import { Header3 } from '../Texts';
import { Dropdown } from '@rewind-ui/core';

import { FaChevronDown } from "react-icons/fa6";
import SideNav from './SideNav';
import LanguageSwitcher from '../LanguageSwitcher';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const location = useLocation().pathname
  const { t } = useTranslation('navbar');
  const { userData, logout, setStartAuth } = useContext(AppContext)

  const [hovered, setHovered] = useState(0)
  const [navOpen, setNavOpen] = useState('tablet:-left-[40vw] -left-[75vw]')

  const UserInitials = () => {
    if (userData) {
      const firstInitial = userData.user_data.first_name.charAt(0).toUpperCase();
      const lastInitial = userData.user_data.last_name.charAt(0).toUpperCase();
      return firstInitial + lastInitial;
    } else {
      return 'UNIDO'
    }
  }

  function getInitials(firstName, lastName) {
    const firstInitial = firstName.charAt(0).toUpperCase();
    const lastInitial = lastName.charAt(0).toUpperCase();
    return firstInitial + lastInitial;
  }

  useEffect(() => {
    console.log(userData)
  }, [userData])

  function toggleNavbar() {
    navOpen == 'left-0' ? setNavOpen('tablet:-left-[40vw] -left-[75vw]') : setNavOpen('left-0')
    return
  }

  return (
    <nav className={`w-full sticky top-0 z-[100] flex flex-row items-center justify-between px-[10px] bg-white transition-all ease-in duration-300 text-black tablet:px-[5vw] desktop:px-[5vw] py-[2vh] shadow-sm`}>
      <div className="logo flex justify-center w-fit">
        <Link to="/">
          <img className='tablet:w-[27vw] desktop:w-[16vw] w-[50vw] object-cover' src="/logos/unido.jpeg" alt="UNIDO Logo" />
        </Link>
      </div>

      <div className="desktop:flex w-fit justify-center hidden">
        <ul className={`flex flex-row justify-center gap-[5vw] w-full items-center`}>
          <li className="relative text-lg">
            <Link className='py-3 text-lg hover:text-green-600' to={'/about'}>
              {t('about')}
            </Link>
          </li>
          <li className="relative text-lg">
            {userData ? (
              <Link className='py-3 text-lg hover:text-green-600' to={'/vetting'}>
                {t('assessment')}
              </Link>
            ) : (
              <span 
                className='py-3 text-lg hover:text-green-600 cursor-pointer' 
                onClick={() => setStartAuth(true)}
              >
                {t('assessment')}
              </span>
            )}
          </li>
          <li className="relative text-lg">
            <Link className='py-3 text-lg hover:text-green-600' to={'/contact'}>
              {t('contact')}
            </Link>
          </li>
        </ul>
      </div>

      <div className="tablet:flex flex-row h-fit relative gap-3 hidden items-center">
        <MenuBtn method={toggleNavbar} />

        {userData ? (
          <Link to={'/general'}>
          <AppButton
              background="bg-gray-900 hover:bg-gray-800 text-white"
            rounded={true}
              text={t('dashboard')}
            />
          </Link>
        ) : (
          <Button
            onClick={() => setStartAuth(true)}
            color='dark'
            pill
            className='bg-gray-900 hover:bg-gray-800 text-white text-base'
          >
            {t('login')}
          </Button>
        )}

        <div className="flex relative h-fit w-fit items-center">
          {userData && (
            <Tooltip
              aria-labelledby="tooltip-no-arrow"
              arrow={false}
              placement='bottom'
              animation='duration-500'
              trigger='click'
              style="light"
              className='bg-transparent cursor-pointer !outline-none p-0'
              content={
                <span className="w-64 justify-center items-center flex flex-col h-fit z-[1001] rounded-lg p-4 bg-white shadow-lg">
                  <Avatar rounded size={'md'} img={userData.user_data.profile_picture || ''} />
                  <Header3 text={`${userData.user_data.first_name} ${userData.user_data.last_name}`} textStyle='w-full text-center text-black !text-xl' />
                  <p className='text-sm text-gray-600'>{userData.user_data.user_email}</p>
                  <div id='tooltip-no-arrow' className="flex flex-row gap-5 pt-2">
                    <div className="flex flex-col items-center justify-center">
                      <Link to={'/profile'} className='m-0 p-0'>
                        <button className='bg-gray-200 p-2 rounded-full hover:!text-blue-600 text-gray-700 hover:bg-blue-200'>
                          <RiUserLine className='text-4xl rounded-full' />
                        </button>
                      </Link>
                      {t('profile')}
                    </div>
                    <div
                      onClick={() => logout()}
                      className="flex flex-col items-center p-2 justify-center">
                      <button className='bg-gray-200 p-2 rounded-full hover:!text-red-600 text-gray-700 hover:bg-red-300'>
                        <RiLogoutCircleRLine className='text-4xl rounded-full' />
                      </button>
                      {t('logout')}
                    </div>
                  </div>
                </span>
              }
              interactive='true'
            >
              <Avatar size={'md'} color={'light'} rounded img={userData.user_data.profile_picture || ''} />
            </Tooltip>
          )}
        </div>

        <LanguageSwitcher />

        <div className="logo flex justify-center w-fit ml-4">
          <a href="https://www.sustainable.co.ke" target="_blank" rel="noopener noreferrer">
            <img className="tablet:w-[20vw] desktop:w-[10vw] w-[40vw] object-cover" src="/logos/logo_base.webp" alt="" />
          </a>
        </div>
      </div>

      <div className="flex mobile:hidden gap-3 justify-center items-center">
        <MenuBtn method={toggleNavbar} />
        <LanguageSwitcher />
        {userData && (
        <div className="flex relative h-fit w-fit items-center">
            <Tooltip
              aria-labelledby="tooltip-no-arrow"
              arrow={false}
              placement='bottom'
              animation='duration-500'
              style="light"
              className='bg-transparent !outline-none p-0'
              content={
                <span className="w-64 justify-center items-center flex flex-col right-0 absolute h-fit z-[1001] rounded-lg p-4 bg-white shadow-lg">
                  <Avatar size={'lg'} color={'light'} rounded img={userData.user_data.profile_picture || ''} />
                  <Header3 text={`${userData.user_data.first_name} ${userData.user_data.last_name}`} textStyle='w-full text-center text-black !text-xl' />
                  <p className='text-sm text-gray-600'>{userData.user_data.user_email}</p>
                  <div id='tooltip-no-arrow' className="flex flex-row gap-5 pt-2">
                    <div className="flex flex-col items-center justify-center">
                      <Link to={'/profile'} className='m-0 p-0'>
                        <button className='bg-gray-200 p-2 rounded-full hover:!text-blue-600 text-gray-700 hover:bg-blue-200'>
                          <RiUserLine className='text-4xl rounded-full' />
                        </button>
                      </Link>
                      {t('profile')}
                    </div>
                    <div
                      onClick={() => logout()}
                      className="flex flex-col items-center p-2 justify-center">
                      <button className='bg-gray-200 p-2 rounded-full hover:!text-red-600 text-gray-700 hover:bg-red-300'>
                        <RiLogoutCircleRLine className='text-4xl rounded-full' />
                      </button>
                      {t('logout')}
                    </div>
                  </div>
                </span>
              }
              interactive='true'
            >
              <Avatar size={'md'} color={'light'} rounded img={userData.user_data.profile_picture || ''} />
            </Tooltip>
        </div>
        )}
      </div>

      <SideNav navOpen={navOpen} setNavOpen={setNavOpen} />
    </nav>
  )
}

export default Navbar
